import React, { ReactNode } from "react";
import styles from "./RadioRowFilter.module.scss";
import Radio from "../../../components/Inputs/Radio/Radio";
import GetText from "../../../i18n/GetText";
import classnames from "classnames";
import { FilterType } from "../../Listing/filters";

/**
 * An exclusive filter that displays as a row of links on desktop and as a vertical radio group on mobile.
 * Clients should sort the filter date into display order.
 */
const RadioRowFilter = ({
  allTextId,
  className,
  inputNamePrefix,
  renderValue,
  filterData,
  isSelected,
  setSelected
}: RadioRowFilterProps) => {
  const nothingSelected = filterData.every((s: FilterType) => !isSelected(s));
  const name = `${inputNamePrefix}-range`;
  return (
    <div className={classnames(className, styles.ageFilterContainer)}>
      <div key="tags" className={styles.tagContainer}>
        <Radio
          key="all"
          selected={nothingSelected}
          label={<GetText id={allTextId} />}
          name={name}
          onChange={() =>
            setSelected(
              filterData.reduce((result, item) => {
                result[item._id] = false;
                return result;
              }, {} as Record<string, boolean>)
            )
          }
          value={"all"}
        />
      </div>
      {filterData.map((value: FilterType) => (
        <div key={value._id} className={styles.tagContainer}>
          <Radio
            label={renderValue({ value })}
            name={name}
            selected={isSelected(value)}
            onChange={() => {
              setSelected(
                filterData.reduce((result, item) => {
                  result[item._id] =
                    item._id === value._id
                      ? !isSelected(value)
                      : isSelected(value);
                  return result;
                }, {} as Record<string, boolean>)
              );
            }}
            value={value.name}
          />
        </div>
      ))}
    </div>
  );
};

export default RadioRowFilter;

interface RadioRowFilterProps {
  allTextId: string;
  className?: string;
  filterData: FilterType[];
  renderValue: (props: { value: FilterType }) => ReactNode;
  inputNamePrefix: string;
  isSelected: (filter: FilterType) => boolean;
  setSelected: (selection: Record<string, boolean>) => void;
}
